import { useMemo } from 'react';
import type { ProductVariantStringListProps } from './types';

export const useProductVariantStringList = ({ options, value, id, onChange, checkOptionAvailability }: ProductVariantStringListProps) => {
  const optionsToRender = useMemo(
    () =>
      options.map(item => {
        const notAvailable = checkOptionAvailability ? !checkOptionAvailability(item.id, id) : false;
        return {
          ...item,
          notAvailable,
        };
      }),
    [options, checkOptionAvailability, id],
  );

  const handleOptionChange = (e: React.ChangeEvent, selectedOptionId: string) => {
    if (onChange) {
      onChange(selectedOptionId);
    }
  };
  const handleMouseOver = (e: React.MouseEvent, selectedOptionId: string) => {};

  return { optionsToRender, handleOptionChange, handleMouseOver, selectedOptionId: value };
};
